module.exports = __webpack_public_path__ + "img/opendoor5.c987a6dc.png";